import React, { useState, useEffect } from 'react';
import StarRating from "./StarRating";


const ratingOptions = [
    { value: 5, text: 'دریافت کامل سفارش و تسویه نقدی پای بار ' },
    { value: 4, text: 'دریافت ناقص سفارش و تسویه پای بار توسط چک ثبت شده' },
    { value: 3, text: 'دریافت سفارش و پرداخت چک بالاتر از مدت توافق شده ' },
    { value: 2, text: 'عدم دریافت سفارش در مرحله اول و یا مانده کردن فاکتور ' },
    { value: 1, text: 'مرجوع کامل سفارش بدون دلیل ' }
];

const RatingModal = ({ show, handleClose, handleSubmit }) => {
    const [selectedScore, setSelectedScore] = useState(null);

    // افکت برای جلوگیری از اسکرول صفحه هنگام باز بودن مودال
    useEffect(() => {
        if (show) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        // با بسته شدن کامپوننت، استایل به حالت اولیه برمی‌گردد
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [show]);

    const handleScoreChange = (e) => {
        setSelectedScore(Number(e.target.value));
    };

    const onSubmitClick = () => {
        if (selectedScore) {
            handleSubmit(selectedScore);
        }
    };

    // اگر show false باشد، هیچ چیزی رندر نمی‌شود
    if (!show) {
        return null;
    }

    return (
        // لایه پس‌زمینه تیره (backdrop)
        <div className="modal-backdrop-custom rtl">
            <div className="modal show d-block" tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header text-center">
                            <h5 className="modal-title text-center fw-bold ">ثبت امتیاز برای سفارش</h5>

                        </div>
                        <div className="modal-body text-small-3 fw-bold">
                            <p className="mb-4 text-center text-primary-color">لطفاً عملکرد مشتری را در این سفارش ارزیابی کنید:</p>
                            <div className="rating-options-container ">
                                {ratingOptions.map(option => (
                                    <div key={option.value} className="rating-option">
                                        <input
                                            type="radio"
                                            id={`score-${option.value}`}
                                            name="vendor_score"
                                            value={option.value}
                                            checked={selectedScore === option.value}
                                            onChange={handleScoreChange}
                                        />
                                        <label htmlFor={`score-${option.value}`}>
                                            <div className="rating-text">{option.text}</div>

                                        </label>

                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="modal-footer ltr">

                            <button
                                type="button"
                                className="btn btn-success w-100"
                                onClick={onSubmitClick}
                                disabled={!selectedScore}
                            >
                                <div className='d-flex justify-content-center mb-3'>
                                    <StarRating score={selectedScore}/>
                                </div>

                                ثبت امتیاز
                            </button>
                            {/*  <button type="button" className="btn btn-secondary" onClick={handleClose}>
                                بستن
                            </button>*/}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RatingModal;

